import {
  CREATE_CAMPAIGN
} from './actionTypes';

import {
  campaignService
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

import {
  SET_ACTION_STATUS_PENDING,
  SET_ACTION_STATUS_SUCCESS,
  SET_ACTION_STATUS_ERROR } from '@/store/helpers';
export default {
  async [CREATE_CAMPAIGN]({ rootState, commit }, campaignData) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: CREATE_CAMPAIGN });
    try {
      const response = await campaignService.createBasicCompletedCampaign(rootState.currentAccountId, campaignData);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: CREATE_CAMPAIGN, campaignId: response?.data?.campaign?.id });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: CREATE_CAMPAIGN, error: e });
    }
  }
};